import {
    ICadastrarDevOps,
    IEditarDevOps,
} from "../../Interfaces/DevOps/DevOps";
import {
    AddCommentInDevOpsBugService,
    CadastrarBugsDevOpsService,
    DeleteCommentInDevOpsBugService,
    EditarBugsDevOpsService,
    GetBugCardDevOpsByIDCasoService,
    LinkUnLinkBugCardsService,
    ListBugCardDevOpsService,
    ListCardHistoryBugDevopsService,
    ListCommentInDevOpsBugService,
    ListFieldValuesDevOpsService,
    SearchBugBoardColumnsDevOpsService,
    SearchUnlinkedBugCardsService,
    UpdateCommentInDevOpsBugService,
} from "../../Services/DevOps/DevOpsService";
import { Controller } from "../Controller";

export async function CadastrarDevOpsController(
    ID_CASO: number,
    requestBody: ICadastrarDevOps
) {
    return Controller(CadastrarBugsDevOpsService(ID_CASO, requestBody));
}

export async function EditarBugsDevOpsController(
    IdCaso: number,
    requestBody: IEditarDevOps
) {
    return Controller(EditarBugsDevOpsService(IdCaso, requestBody));
}

export async function ListFieldValuesDevOpsController(field: string) {
    return Controller(ListFieldValuesDevOpsService(field));
}

export async function GetBugCardDevOpsByIDCasoController(IdCaso: number) {
    return Controller(GetBugCardDevOpsByIDCasoService(IdCaso));
}

export async function SearchBugBoardColumnsDevOpsController() {
    return Controller(SearchBugBoardColumnsDevOpsService());
}

export async function ListBugCardDevOpsController(requestBody: {
    pageNumber: number;
    itemsPerPage: number;
    flAtivo: boolean;
    idUsuario: number;
}) {
    return Controller(ListBugCardDevOpsService(requestBody));
}

export async function AddCommentInDevOpsBugController(
    IdCardDevOps: number,
    requestBody: string
) {
    return Controller(AddCommentInDevOpsBugService(IdCardDevOps, requestBody));
}

export async function ListCommentInDevOpsBugController(IdCardDevOps: number) {
    return Controller(ListCommentInDevOpsBugService(IdCardDevOps));
}

export async function UpdateCommentInDevOpsBugController(
    IdCardDevOps: number,
    IdCommentDevOps: number,
    requestBody: string
) {
    return Controller(
        UpdateCommentInDevOpsBugService(
            IdCardDevOps,
            IdCommentDevOps,
            requestBody
        )
    );
}

export async function DeleteCommentInDevOpsBugController(
    IdCardDevOps: number,
    IdCommentDevOps: number
) {
    return Controller(
        DeleteCommentInDevOpsBugService(IdCardDevOps, IdCommentDevOps)
    );
}

export async function SearchUnlinkedBugCardsController(NrDevOpsCard: string) {
    return Controller(SearchUnlinkedBugCardsService(NrDevOpsCard));
}

export async function LinkUnLinkBugCardsController(
    NrDevOpsCard: number,
    idCaso: number,
    flLinkCard: boolean
) {
    return Controller(
        LinkUnLinkBugCardsService(NrDevOpsCard, idCaso, flLinkCard)
    );
}

export async function ListCardHistoryBugDevopsController(idCardDevOps: number) {
    return Controller(ListCardHistoryBugDevopsService(idCardDevOps));
}
